<template>
    <div>
        <div class="box view-nav-bar">
            <div class="d-flex align-items-center w-100">
                <span class="text-muted">
                    Brightfish admissions per cinema — last <strong>{{ bucket.weeks || 52 }}</strong> cinema weeks
                    <span v-if="bucket.first_week">({{ bucket.first_week }} → {{ bucket.last_week }})</span>
                </span>
            </div>
        </div>

        <div v-if="loading" class="box">
            <div class="box-content text-center text-muted py-4">Loading…</div>
        </div>

        <div v-else-if="!rows.length" class="box">
            <div class="box-content text-center text-muted py-4">No admissions data found.</div>
        </div>

        <div v-else class="box">
            <div class="box-content">
                <table class="shx-table w-100 mt-2">
                    <thead>
                        <tr>
                            <th class="shx-th-80">Code</th>
                            <th>Cinema</th>
                            <th class="shx-th-140">City</th>
                            <th class="text-right">Admissions</th>
                            <th class="text-right shx-th-100"># Weeks</th>
                            <th class="text-right shx-th-120">Avg / week</th>
                            <th class="text-right shx-th-100">Real %</th>
                            <th class="shx-th-120"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in rows" :key="row.theatre_code">
                            <td>
                                <router-link :to="'/admissions/cinema/' + row.theatre_code">{{ row.theatre_code }}</router-link>
                            </td>
                            <td>{{ row.theatre_name || '—' }}</td>
                            <td>{{ row.city || '—' }}</td>
                            <td class="text-right">{{ formatInt(row.admissions) }}</td>
                            <td class="text-right">
                                {{ row.weeks }}
                                <span v-if="row.weeks < bucket.weeks"
                                      class="badge badge-warning ml-1"
                                      :title="missingTitle(row)">⚠</span>
                            </td>
                            <td class="text-right">{{ row.avg_week !== null ? formatInt(row.avg_week) : '—' }}</td>
                            <td class="text-right">
                                <span>{{ row.real_weighted != null ? row.real_weighted + '%' : '—' }}</span>
                                <span v-if="row.real_weighted != null && row.real_weighted <= 90"
                                      class="badge badge-warning ml-1"
                                      :title="'Minimum real: ' + row.real_min + '%'">⚠</span>
                            </td>
                            <td>
                                <router-link :to="'/admissions/cinema/' + row.theatre_code"
                                             class="btn btn-sm btn-outline-secondary">
                                    Per Year
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="3"><strong>Total</strong></td>
                            <td class="text-right"><strong>{{ formatInt(totalAdmissions) }}</strong></td>
                            <td colspan="4"></td>
                        </tr>
                    </tfoot>
                </table>
                <p class="text-muted small mt-2 mb-0">
                    All figures come from <code>admissions_week</code>, saleshouse BF, compiled and estimated weeks alike.
                    <strong>Real %</strong> is the admissions-weighted average of the <code>real</code> field:
                    97.5 means every week was compiled from Cinedata, lower values mean part of the total was estimated.
                    ⚠ on the week count marks cinemas without a row for every week of the period.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'AdmissionsCinemas',
    data() {
        return {
            loading: true,
            bucket: {},
            rows: [],
        };
    },
    computed: {
        totalAdmissions() {
            return this.rows.reduce((sum, r) => sum + (r.admissions || 0), 0);
        },
    },
    created() {
        this.loadCinemas();
    },
    methods: {
        loadCinemas() {
            this.loading = true;
            axios
                .get('/admissions/cinema')
                .then(response => {
                    this.bucket = response.data.data.bucket || {};
                    this.rows = response.data.data.rows || [];
                })
                .catch(error => {
                    this.$toast.error(error.response?.data?.error?.message || error.message);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        missingTitle(row) {
            return `${this.bucket.weeks - row.weeks} of ${this.bucket.weeks} weeks without data`;
        },
        formatInt(v) {
            return Math.round(v || 0).toLocaleString();
        },
    },
};
</script>
